<template>
  <div id="map-controls-sidebar-vehicle">
    <div class="h-full">

      <template v-if="vehicleList.length === 0">
        <div class="py-4 px-6">
          <h5 class="no-vehicle">登録されている車両はありません</h5>
        </div>
      </template>

      <div
        class="scroll-area--customizer pb-12 vehicle-list-area"
        :settings="settings"
        :key="$vs.rtl"
      >
        <ul>
          <li
            v-for="vehicle in vehicleList"
            :key="vehicle.trackimo_id"
            class="pb-2 pl-4 pr-4 vehicle-li"
          >
            <vehicle-card
              :vehicle="vehicle"
            ></vehicle-card>
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import VehicleCard from "./VehicleCard";

export default {
  components: {
    VehicleCard
  },
  props: {
    vehicleList: Array,
  },
  data() {
    return {
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      timerId: null
    };
  },
  computed: {
    rtl: {
      get() {
        return this.$vs.rtl;
      },
      set(val) {
        this.$vs.rtl = val;
      }
    },
  },
  methods: {
  },
  beforeDestroy() {
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#map-controls-sidebar-vehicle {
  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1.0;
  }
  .vehicle-card {
    .vehicle-body-area {
      height: 5.6rem;
    }
    .vehicle-label {
      height: 1.6rem;
    }
    img {
      width: 100%;
      object-fit: cover;
    }
    .vehicle-img-area {
      position: relative;
    }
    .vehicle-info-area {
      span {
        font-size: 12px;
      }
    }
    .vx-card{
      background: $aisea-blue-gray;
    }
    .vx-card__body{
      padding: 1.0rem;
    }
  }
  .vehicle-list-area{
    background-color: #2C3241;
  }
  .vehicle-li{
    padding: 0;
  }
  .no-vehicle{
    color: $aisea-white;
  }
}
</style>
